import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import Variables from "./Variables";
import swal from 'sweetalert';
import PropTypes from "prop-types";
import askDelayAndConfirm from "../Common/askDelayAndConfirm";

const Phone = (props) => {

  const { sendSMS, sendEmail, smsModel, isLoading } = props;

  const [channel, setChannel]   = useState('sms'); // 'sms' | 'email'
  const [cause, setCause]       = useState('');
  const [start, setStart]       = useState('');
  const [end, setEnd]           = useState('');
  const [content, setContent]   = useState(null);
  const [cost, setCost]         = useState(0);
  const [freeMode, setFreeMode] = useState(false);
  const [freeContent, setFreeContent]   = useState('');
  const [emailContent, setEmailContent] = useState('');

  const sprintf = require('sprintf-js').sprintf;

  useEffect(() => {
    if (freeMode) {
      // Mode libre : utiliser le contenu libre
      setContent(freeContent);
      var lengthContent = freeContent.length;
      setCost(4 * Math.ceil(lengthContent / 140));
    } else {
      // Mode gabarit : utiliser le modèle avec les variables
      var c = sprintf(smsModel, cause, start, end, '0*********');
      setContent(c);
      // Cout du sms
      // @source https://dev.mailjet.com/sms/guides/encoding/
      // Je divise par 140 pour prévoir les accents qui comptent pour plus de caractères
      var lengthContent = c.length;
      setCost(4 * Math.ceil(lengthContent / 140));
    }
  }, [cause, start, end, smsModel, sprintf, freeMode, freeContent]);


  /**
   * Gère le changement des variables pour le sms
   */
  const handleVariablesChange = (variableName, value) => {
    if (variableName === 'cause') {
      setCause(value);
    }
    if (variableName === 'start') {
      setStart(value);
    }
    if (variableName === 'end') {
      setEnd(value);
    }
  }

  const areVariablesOk = () => {
    if (channel === 'email') {
      return emailContent.trim() !== '';
    }
    if (freeMode) {
      return freeContent.trim() !== '';
    }
    return cause !== '' && start !== '' && end !== '';
  }

  /**
   * Envoie le sms ou l'email
   */
  const send = () => {

    if (!areVariablesOk()) {
      const message = channel === 'email'
        ? "Merci de renseigner le contenu de l'email avant d'envoyer"
        : freeMode
          ? "Merci de renseigner le contenu du SMS avant d'envoyer"
          : "Merci de renseigner une cause et un retard estimé avant d'envoyer le SMS";
      swal({
        title: "Pas si vite !",
        text: message,
        icon: "warning",
        buttons: { ok: "Ok" },
      })
      return;
    }

    // Confirmation + « ce message annonce-t-il un retard ? » (Oui / Non).
    const summary = channel === 'sms'
      ? "Vous allez envoyer un SMS à tous les clients ayant commandé aujourd'hui sur ces points/charrettes."
      : "Vous allez envoyer un email à tous les clients sélectionnés.";
    askDelayAndConfirm(summary, channel)
    .then((isDelay) => {
      if (isDelay === null) {
        return;
      }
      if (channel === 'email') {
        sendEmail(emailContent, isDelay);
      } else if (freeMode) {
        sendSMS(null, null, null, freeContent, isDelay);
      } else {
        sendSMS(cause, start, end, null, isDelay);
      }
    });
  }

  return (
    <>
      <ChannelSelector>
        <ChannelButton active={channel === 'sms'} onClick={() => setChannel('sms')}>
          📱 SMS
        </ChannelButton>
        <ChannelButton active={channel === 'email'} onClick={() => setChannel('email')}>
          ✉️ Email
        </ChannelButton>
      </ChannelSelector>

      {channel === 'email' ? (
        <EmailCard>
          <EmailTitle>Bonjour $prenom,</EmailTitle>
          <EmailTextarea
            value={emailContent}
            onChange={(e) => setEmailContent(e.target.value)}
            placeholder="Saisissez le texte libre de votre email..."
            rows={8}
          />
          <Save>
            {isLoading
              ? <button disabled="true">En cours...</button>
              : <button onClick={() => send()}>Envoyer l'email</button>
            }
          </Save>
        </EmailCard>
      ) : (
        <Iphone>
          <i>Speaker</i>
          <b>Camera</b>
          <ModeToggle>
            <label>
              <input
                type="checkbox"
                checked={freeMode}
                onChange={(e) => setFreeMode(e.target.checked)}
              />
              <span style={{ color: 'white', paddingLeft: '1.5rem' }}>Mode libre</span>
            </label>
          </ModeToggle>
          {freeMode ? (
            <FreeModeContainer>
              <FreeTextarea
                value={freeContent}
                onChange={(e) => setFreeContent(e.target.value)}
                placeholder="Saisissez votre message SMS personnalisé (limité à 420 caractères)..."
                rows={6}
                maxLength={420}
              />
            </FreeModeContainer>
          ) : (
            <Variables
              handleChange={handleVariablesChange}
              cause={cause}
              start={start}
              end={end}
            />
          )}
          <Badge><div>Estimation du coût du sms: {cost / 100} €</div></Badge>
          <p>{content}</p>
          <Save>
            {isLoading
              ? <button disabled="true">En cours...</button>
              : <button onClick={() => send()}>Envoyer le SMS</button>
            }
          </Save>
        </Iphone>
      )}
    </>
  );
};

const ChannelSelector = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 1rem 0;
`;

const ChannelButton = styled.button`
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  border: 2px solid #429853;
  background-color: ${({ active }) => active ? '#429853' : 'white'};
  color: ${({ active }) => active ? 'white' : '#429853'};
  font-weight: bold;
  cursor: pointer;
  transition: 200ms;
  &:hover {
    opacity: 0.85;
  }
`;

const EmailCard = styled.div`
  max-width: 500px;
  margin: 0 auto;
  background: #f9f9f9;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const EmailTitle = styled.div`
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
  font-size: 1rem;
`;

const EmailTextarea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  resize: vertical;
  min-height: 150px;
  font-family: inherit;
  &:focus {
    outline: none;
    border-color: #429853;
  }
`;

const ModeToggle = styled.div`
  padding: 1rem;
  padding-bottom: 0;
  label {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    gap: 0.5rem;
    color: white;
    cursor: pointer;
    input[type="checkbox"] {
      cursor: pointer;
    }
  }
`;

const FreeModeContainer = styled.div`
  padding: 0 1rem;
`;

const FreeTextarea = styled.textarea`
  width: 100%;
  padding: 0.5rem;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1rem;
  resize: vertical;
  min-height: 100px;
  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.6);
    background-color: rgba(255, 255, 255, 0.15);
  }
`;

const Badge = styled.div`
  padding: 0rem 1.0rem 0.5rem 1rem;
  div{
    padding: 0.2rem;
    border-radius: 50px;
    text-align: center;
    background-color: #111;
    color: white;
  }
`;

const Iphone = styled.div`
    position: relative;
    margin: 40px auto;
    width: 320px;
    background-color: rgb(66,152,83);
    background-image: linear-gradient(60deg, rgb(66,152,83) 1%,rgb(144,163,69) 100%);
    border-radius: 40px;
    box-shadow: 0px 0px 0px 11px #1f1f1f, 0px 0px 0px 13px #191919, 0px 0px 0px 10px #111;
    &:before,
    &:after{
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    &:after {
      bottom: 7px;
      width: 140px;
      height: 4px;
      background-color: #f2f2f2;
      border-radius: 10px;
    }

    i,b,s,span {
      position: absolute;
      display: block;
      color: transparent;
    }
    i {
      top: 5px;
      left: 50%;
      transform: translate(-50%, 6px);
      height: 8px;
      width: 15%;
      background-color: #101010;
      border-radius: 8px;
      box-shadow: inset 0px -3px 3px 0px rgba(256, 256, 256, 0.2);
    }
    b {
      left: 10%;
      top: 5px;
      transform: translate(180px, 4px);
      width: 12px;
      height: 12px;
      background-color: #101010;
      border-radius: 12px;
      box-shadow: inset 0px -3px 2px 0px rgba(256, 256, 256, 0.2);
      &:after {
        content: '';
        position: absolute;
        background-color: #2d4d76;
        width: 6px;
        height: 6px;
        top: 2px;
        left: 2px;
        top: 3px;
        left: 3px;
        display: block;
        border-radius: 4px;
        box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);
      }
    }
    p {
      color: #fff;
      text-align: left;
      text-decoration: none;
      width: 100%;
      font-size: 1.2rem;
      font-weight: 100;
      padding: 0.5rem 1.0rem 8.0rem 1.0rem;
    }

`;

const Save = styled.div`
  text-align: center;
  button {
    transition: 300ms;
    width: auto;
    border-radius: 50px;
    margin-bottom: 2.0rem;
    background-color: white;
    color: #111;
    border: none;
    padding: 0.5rem 2.5rem;
    &:hover {
      opacity: 0.7;
    }
    :disabled,
    button[disabled] {
      opacity: 0.5;
    }
  }
`;

Phone.propTypes = {
  sendSMS: PropTypes.func,
  sendEmail: PropTypes.func,
  smsModel: PropTypes.string,
  isLoading: PropTypes.bool
};

Phone.defaultProps = {
  smsModel: '',
  isLoading: false
};

export default Phone;
